import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloads only the lazy routes explicitly flagged with `data: { preload: true }`.
 *
 * Angular's `RouterPreloader` runs this *after* the initial navigation settles,
 * so flagged chunks are fetched in the background and are already warm by the
 * time the user interacts. This is what makes the first document click on a
 * cold cache open immediately instead of stalling behind the sequential
 * `import()` of the `information-unit-view` chunk (which eagerly bundles
 * `ngx-extended-pdf-viewer`) and the rendition chunk.
 *
 * Unflagged lazy routes (upload flow, landing, legal, …) are left on-demand, so
 * this stays selective — unlike `PreloadAllModules`, which would eagerly pull
 * every chunk for every user.
 */
@Injectable({ providedIn: 'root' })
export class PreloadFlaggedStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] ? load() : of(null);
  }
}
